export default "__VITE_ASSET__a65840e7__"